<template>
    <div v-if="standard" class="text-sm mt-2 mb-4">
        {{$t('STANDARD_IS')}} {{standard}}
    </div>
</template>

<script>
    export default {
        props: {
            placement: Object,
        },

        computed: {
            standard() {
                return this.placement.custom?.['v-standard'];
            },
        },
    };
</script>
